import React from 'react';
import styled from 'styled-components';
import './estilo-header.css';
import { withRouter } from 'react-router-dom';
import {
    getItemDatosSesion,
    borrarDatosSesion,
    setDatosSesion
} from '../../../../funciones_globales/manejosesion';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionMenu } from '../../../../actions/generales/act_gen01';
import global_axios from '../../../../funciones_globales/interaccionapi';
import io from "socket.io-client";
import ComponenteAprobacion from '../../../../componentes/componentes_generales/aprobaciones/ComponenteAprobacion';
import { VERSION } from '../../../../app.constants';
import { api as API_BASE_URL} from '../../../../config';
import {validarAccesoATransaccion} from "../../../../funciones_globales/accionesPorUsuario";

const Encabezado = styled.header`
    position: fixed;    
    height: 30px;
    margin: 0;
    margin: 0;
    padding-bottom: 10px;
    background-color: #e0e0e0;
    border-bottom: 2px solid #999999;
    width: 100%;
    z-index: 1000;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;   
`;

const MenuDesplegable = styled.div`    
    float: right;    
    display: inline-block;
    position: relative;
    color: black;
    padding-top: 3px;    
`;

const SelectEmpresa = styled.select`
    font-size: 11px;
`;

const ListaItemsConfiguracion = styled.ul`
    font-size: 10px;    
    display: inline-block;
    position: relative;
    padding-left: 5px;
    padding-bottom: 10px;
    @media (max-width: 767px) {
        display: none;
    }    
`;

const ItemConfiguracionEmpresa = styled.li`
    display: inline;
    padding-right: 75px;
    font-weight: 600;
    font-size: 11px;
`;

const ItemConfiguracion = styled.li`
    display: inline;
    margin-right: 10px;
`;

const TituloItemConfig = styled.span`
    font-weight: 600;
`;

const BotonEnEncabezado = styled.a`
    margin-top: 4px;
    margin-left: 15px;
    margin-right: ${props => props.margen_derecho?props.margen_derecho:0}px;
    color: black;
    font-size: 20px;
    &:hover {
        text-decoration: none;
    };
    @media (max-width: 767px) {
        margin-top: 5px;
    };
    cursor: pointer;
`;

const proformaAudio = new Audio("/sonidos/proforma-notification.mp3");
const FEATURE_CONSULTAR_PROF_X_IMPRIMIR = 'CONSULTAR_PROFORMAS_POR_IMPRIMIR';

class Header extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            visible_opc_sesion: false,
            empresas: getItemDatosSesion('empresasPerfil')? JSON.parse(getItemDatosSesion('empresasPerfil')): [],
            empresa_cod_sel: getItemDatosSesion('empresaActual')? JSON.parse(getItemDatosSesion('empresaActual')).Db:'',
            empresa_descrip_sel: getItemDatosSesion('empresaActual')? JSON.parse(getItemDatosSesion('empresaActual')).Nomb.toString().trim().toUpperCase(): '',
            modalVisible: false,
            modalVisibleGlobal: false,
            usuario_final: null,
            ip: API_BASE_URL,
            socket: null,
            usuariosSolicitantes: [],
            interval: null,
            mensajes: [],
            mensajesGlobal: [],
            solicitudes: [],
            audio: null,
            showProformasPorImprimir: true,
            nroProformasPorImprimir: null
        }

        this.logOut = this.logOut.bind(this);
        this.cambiarClave = this.cambiarClave.bind(this);
        this.mostrarDesplegableOpcSesion = this.mostrarDesplegableOpcSesion.bind(this);        
        this.seleccionarEmpresa = this.seleccionarEmpresa.bind(this);
        this.cambiarVisualizacionMenu = this.cambiarVisualizacionMenu.bind(this);
        this.ocultarDesplegableOpcSesion = this.ocultarDesplegableOpcSesion.bind(this);
        this.mostrarModal= this.mostrarModal.bind(this);
        this.addUserAprobador = this.addUserAprobador.bind(this);
        this.cargarMensajesAprobador = this.cargarMensajesAprobador.bind(this);
        this.actualizarUsuariosSolicitantes= this.actualizarUsuariosSolicitantes.bind(this);
        this.reproducir= this.reproducir.bind(this);
    }

    addUserAprobador(socket){
        return new Promise((resolve, reject) => {
          //Se recibe los usuarios aprobadores conectados.
          //Se emite el evento de añadir al usuario al registro de usuarios en el servidor
          var usuario={};
          var user=getItemDatosSesion('usuario').toString();
          usuario.usuario=user;
          usuario.nombre= (this.state.usuario_final!==null && this.state.usuario_final!==undefined)?this.state.usuario_final.NombreUsuario.trim():'';
          usuario.detAprobaciones= this.state.usuario_final.detAprobaciones;
          socket.emit("addUserAprobador", usuario);
          //Se recibe la respuesta del emit anterior
          socket.on("confirmacionIngresoUsuarioAprobador",function(data){
            resolve(data)
          })
        });
    }

    cargarMensajesAprobador(socket){ //Willy 2019-10-04
        return new Promise((resolve, reject) => {
          //Se envia una peticion para recuperar las solicitudes enviadas al usuario aprobado
          socket.emit("cargarMensajesAprobador",this.state.usuario_final.Login.trim());
          //Se recibe la respuesta del emit anterior
          socket.on("respuestaMensajeAprobador",function(data){
            resolve(data)
          })
        });
    } 

    mostrarDesplegableOpcSesion(event){
        event.preventDefault();
        this.setState({
            visible_opc_sesion: !this.state.visible_opc_sesion
        })        
    }

    ocultarDesplegableOpcSesion(event){
        event.preventDefault();
        this.setState({
            visible_opc_sesion: false
        })        
    }

    logOut(){
        let salir = window.confirm('¿Está seguro de cerrar sesión?');
        if (salir){
            if(this.state.socket!==null){
                if(this.state.socket.connect){
                    console.log('El usuario con id de socket '+ this.state.socket.id + "se desconecto.");
                    this.setState({modalVisible:false})
                    var user=getItemDatosSesion('usuario');
                    var usuario={};
                    usuario.usuario=(user!==null && user!==undefined)? user.trim():'';
                    this.state.socket.emit('deleteUserAprobador',usuario)
                    this.state.socket.on("confirmacionEliminacionUsuarioAprobador",function(data){
                    })
                }
            }
            borrarDatosSesion();
            this.props.history.push("/login");            
        }
    }

    cambiarClave(){        
        this.props.history.push("/cambioclave");
    }

    seleccionarEmpresa(event){
        if (event.target.value !== this.state.empresa_cod_sel){            
            let resp_alerta_1 = window.confirm('¿Está seguro de cambiar la empresa actual?');
            if (resp_alerta_1){
                let resp_alerta_2 = window.confirm('Se procederá a setear la sesión actual con los datos de la empresa seleccionada. ¿Está seguro de continuar?');
                if (resp_alerta_2){
                    this.state.empresas.forEach((empresa) => {
                        if (event.target.value === empresa.infoempresa.NombreBaseDatos.toString().trim()){
                            this.setState({empresa_cod_sel: event.target.value, empresa_descrip_sel: empresa.infoempresa.NombreEmpresa.toString().trim()});                            
                            
                            setDatosSesion('empresaActualId', empresa.infoempresa.NombreBaseDatos.toString().trim());
                            setDatosSesion('empresaActualDescrip', empresa.infoempresa.NombreEmpresa.toString().trim());                        

                            this.setState({visible_opc_sesion: false});                            
                            this.props.history.push("/");
                        }
                    });                            
                }else{
                    this.setState({visible_opc_sesion: false});
                }
            }else{
                this.setState({visible_opc_sesion: false});
            }        
        }
    }

    reproducir(){
        var audio = this.state.audio;
        if(audio!==null){
            var playPromise = audio.play();
            if (playPromise !== undefined) {
                playPromise
                .then(_ => {
                    console.log("audio played auto");
                })
                .catch(error => {
                    audio.pause();
                    audio.play();
                });
            }
        }
    }

    componentDidMount() {
        var user=getItemDatosSesion('usuario');
        global_axios({
            method: 'GET',
            url: '/usuarios/aprobador/' + user
        }).then( (aprobador) => {
            var socket= io(this.state.ip,{transports:['websocket'],upgrade:false})
            if(aprobador.data!==null){
                this.setState({usuario_final:aprobador.data,socket:socket},()=>{
                    this.addUserAprobador(this.state.socket).then((data)=>{
                            let usuariosSolicitantes=[];
                            if(data.acceso){
                                for(let i =0; i < data.usuariosSolicitantesTransferencia.length ; i++){
                                    let usuario={}
                                    usuario.value=data.usuariosSolicitantesTransferencia[i].socketId;
                                    usuario.label=data.usuariosSolicitantesTransferencia[i].nombre;
                                    usuario.usuario= data.usuariosSolicitantesTransferencia[i].usuario;
                                    usuariosSolicitantes.push(usuario)
                                }

                                //Se procede a cargar las solicitudes recibidas del aprobador.
                                this.cargarMensajesAprobador(this.state.socket).then((solicitudesCarga)=>{
                                    var solicitudes= [];
                                    //Se recorre las solicitudes para ingresar solamente las que corresponden al usuario administrador.
                                    for(let j=0; j<solicitudesCarga.transaccionesSolicitantes.length; j++){
                                        if(solicitudesCarga.transaccionesSolicitantes[j].paraUsername=== this.state.usuario_final.Login.trim()){//Se inserta
                                            solicitudes.push(solicitudesCarga.transaccionesSolicitantes[j]);
                                        }
                                    }
                                    this.setState({solicitudes});
                                })
                                this.setState({usuariosSolicitantes,audio:new Audio('/sonidos/notificacion.mp3')})
                            }
                            else{
                                alert("El Usuario ya posee una sesión iniciada")
                            }
                        })
                        this.state.socket.on('disconnect', () => {
                            console.log('El usuario con id de socket '+   this.state.socket.id + "se desconecto.");
                            this.setState({modalVisible:false})
                            var user=getItemDatosSesion('usuario');
                            var usuario={};
                            usuario.usuario=(user!==null && user!==undefined)?user.trim():'';
                            this.state.socket.emit('deleteUserAprobador',usuario)
                            this.state.socket.on("confirmacionEliminacionUsuarioAprobador",function(data){
                            })
                        });
                        this.state.socket.on("recibirSolicitud",function(data) {
                            var solicitudes= [];
                            //Se recorre las solicitudes para ingresar solamente las que corresponden al usuario administrador.
                            for(let i=0; i<data.transaccionesSolicitantes.length; i++){
                                if(data.transaccionesSolicitantes[i].paraUsername=== this.state.usuario_final.Login.trim()){//Se inserta
                                    solicitudes.push(data.transaccionesSolicitantes[i]);
                                }
                            }

                            if(data.sonido){
                                document.getElementById("sonido").click();
                            }

                            this.setState({solicitudes})
                        }.bind(this));
                })
            }
        }).catch((error)=>{
            alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);
        })

        /***** PROFORMAS POR IMPRIMIR INITIAL COUNTER & SERVER SENT: EVENTS *****/
        const perfilId = JSON.parse(getItemDatosSesion('perfil')).Id;
        Promise.all(
            [ validarAccesoATransaccion(FEATURE_CONSULTAR_PROF_X_IMPRIMIR, getItemDatosSesion('usuario'), perfilId), ])
        .then(([accesoConsultarProformasPorImprimir ]) => {
            const showProformasPorImprimir = accesoConsultarProformasPorImprimir.accesoPermitido === true;
            this.setState({showProformasPorImprimir: showProformasPorImprimir}, async () => {
                if(showProformasPorImprimir){

                    const response = await global_axios({method: 'GET', url: '/proformas/summaries/to-print'});
                    this.setState({ nroProformasPorImprimir: response.data.counter });

                    const events = new EventSource(API_BASE_URL + '/events');

                    events.addEventListener('proformasPorImprimirAdded', (event) => {
                        const eventData = JSON.parse(event.data);
                        this.setState({ nroProformasPorImprimir: eventData.proformasPorImprimir }, ()=> {
                            try {
                                proformaAudio.play();
                            } catch (error) {
                                console.error("No se puede reproducir sonido de alerta: 'proforma-por-imprimir'");
                            };
                        });
                    }, false);

                    events.addEventListener('proformasPorImprimirRemoved', (event) => {
                        const eventData = JSON.parse(event.data);
                        this.setState({ nroProformasPorImprimir: eventData.proformasPorImprimir });
                    }, false);
                }
            });
        });
        /*****************************************************/
    }

    cambiarVisualizacionMenu(event){
        event.preventDefault();
        this.props.cambiar_VisualizacionMenu(!this.props.isVisibleMenu);       
    }

    actualizarUsuariosSolicitantes(){
        new Promise((resolve, reject) => {
          this.state.socket.emit("actualizarUsuariosSolicitantes","");
          this.state.socket.on("actualizarUsuariosSolicitantes",function(data){
            resolve(data)
          })
        }).then((datos)=>{
            let usuariosSolicitantes=[];
            for(let i =0; i < datos.usuariosSolicitantesTransferencia.length ; i++){
              let usuario={}
              let formularios= this.state.usuario_final.detAprobaciones;
              let encontradoFormulario = false;
              for(let j=0; j< formularios.length; j++){ //Se recorre los formularios sobre los cuales tiene aprobación el usuario conectado.
                //Se pregunta si los usuarios solicitantes poseen un formulario que pueda aprobar el usuario conectado, si es verdadero entonces el usaurio aprobador podra ver esos usuarios, caso contrario no podra visualizarlos.
                if(datos.usuariosSolicitantesTransferencia[i].codigo_formulario===formularios[j].CodigoFormulario){
                    encontradoFormulario=true;
                }
              }
              if(encontradoFormulario){
                usuario.value=datos.usuariosSolicitantesTransferencia[i].socketId;
                usuario.label=datos.usuariosSolicitantesTransferencia[i].nombre;
                usuario.usuario= datos.usuariosSolicitantesTransferencia[i].usuario;
                usuariosSolicitantes.push(usuario)
              }
              
            }
            var solicitudes= this.state.solicitudes;
            this.setState({usuariosSolicitantes,solicitudes})
        });
      }

    mostrarModal(){
        this.setState({modalVisible:true})
    }

    apagarEventosSocket(socket){
        socket.off('confirmacionEliminacionUsuarioAprobador')
        socket.off('confirmacionIngresoUsuarioAprobador')
        socket.off('actualizarUsuariosSolicitantes')
        socket.off('recibirSolicitud')
    }

    render(){       
        return(
            <Encabezado>
                <BotonEnEncabezado className={this.props.isVisibleMenu?'fa fa-times':'fa fa-bars'} onClick={this.cambiarVisualizacionMenu}/>
                <BotonEnEncabezado margen_derecho={10} className='fa fa-home' onClick={()=>{this.props.history.push('/')}}/>
                <ListaItemsConfiguracion>
                    <ItemConfiguracionEmpresa><TituloItemConfig>Empresa: </TituloItemConfig>{this.state.empresa_descrip_sel}</ItemConfiguracionEmpresa>
                    <ItemConfiguracion><TituloItemConfig>Perfil: </TituloItemConfig>{getItemDatosSesion('perfil')? JSON.parse(getItemDatosSesion('perfil')).Nomb.toString().trim().toUpperCase(): ''}</ItemConfiguracion>
                    <ItemConfiguracion><TituloItemConfig>Periodo: </TituloItemConfig>{getItemDatosSesion('periodo')? getItemDatosSesion('periodo').toString().trim(): ''}</ItemConfiguracion>                    
                    <ItemConfiguracion><TituloItemConfig>Versión: </TituloItemConfig>{VERSION}</ItemConfiguracion>
                    { this.state.showProformasPorImprimir && <div className='cont-notif-proformas'>Proformas Por Imprimir <span className='cont-notif-proformas badge'>{this.state.nroProformasPorImprimir}</span></div> }
                </ListaItemsConfiguracion>
                <BotonEnEncabezado  margen_derecho={10} className={this.state.usuario_final!==null?'fa fa-commenting':'invisible'} onClick={this.mostrarModal}/>
                <ListaItemsConfiguracion className={this.state.usuario_final!==null?'':'invisible'} >Solicitudes sin leer:<ItemConfiguracion>{this.state.solicitudes.length}</ItemConfiguracion></ListaItemsConfiguracion>
                <button type="button" id="sonido" style={{display:'none'}} onClick={this.reproducir}></button>
                <MenuDesplegable>
                    <a className='usuario-activo' onMouseOver={this.mostrarDesplegableOpcSesion} href='!#'>
                        <i className='fa fa-user'/>{' ' + getItemDatosSesion('usuario') + ' '}<i className="fa fa-caret-down"/>
                    </a>
                    <div className={this.state.visible_opc_sesion?'visible menu-despleg-opcsesion': 'no-visible menu-despleg-opcsesion'} onMouseLeave={this.ocultarDesplegableOpcSesion}>
                        <div className='titulo-opc-sesion'><span>Opciones de sesión</span></div>
                        <div className='opc-sesion'>
                            <span>Empresa:</span>
                        </div>
                        <div className='opc-sesion'>   
                            <SelectEmpresa onChange={this.seleccionarEmpresa} value={this.state.empresa_cod_sel}>
                                {
                                    this.state.empresas.map((empresa)=>{
                                        return  <option key={empresa.CodigoEmpresa} value={empresa.infoempresa.NombreBaseDatos.toString().trim()}>{empresa.infoempresa.NombreEmpresa.toString().trim()}</option>
                                    })
                                } 
                            </SelectEmpresa>                            
                        </div>
                        <div className='opc-sesion'>
                            <button className='btn-opcsesion btn-cambioClave' onClick={this.cambiarClave}><i className='fa fa-key'/> Cambiar contraseña</button>
                            <button className='btn-opcsesion btn-salir' onClick={this.logOut}><i className='fa fa-sign-out'/> Cerrar sesión</button>
                        </div>
                    </div>
                </MenuDesplegable>
                <ComponenteAprobacion
                        visible={this.state.modalVisible}
                        title="Aprobador"
                        onClose={()=>{this.setState({modalVisible: false})}}
                        usuario={this.state.usuario_final}
                        socket={this.state.socket}
                        mensajes={this.state.mensajes}
                        usuariosSolicitantes={this.state.usuariosSolicitantes}
                        solicitudes={this.state.solicitudes}
                />
            </Encabezado>
        );        
    }
}

const mapStateToProps = ((state) => {
    return {isVisibleMenu: state.ui.isVisibleMenu}
});

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ cambiar_VisualizacionMenu }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));